import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=0f3ab360"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=0f3ab360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports